import React from 'react';
import styled from 'styled-components';

import SpeedyButton from '../SpeedyButton';

const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  margin: 0 auto;
  max-width: 480px;
  padding: 0 30px;
`;

const Button = styled(SpeedyButton)`
  display: block;
  flex: 1 1 0px;
  text-transform: uppercase;
`;

const Controls = ({ nextHandler, prevHandler }) => (
  <Wrapper>
    <Button type="prev" onClick={prevHandler}>Previous</Button>
    <Button type="next" onClick={nextHandler}>Next</Button>
  </Wrapper>
);

export default Controls;
